import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { RaceRegistrationService, RegistrationWindow } from '../../service/raceRegistration.service';
import { AuthService } from '../../../auth.service';

@Component({
    selector: 'app-registration-announcement-widget',
    standalone: true,
    imports: [CommonModule, RouterModule, ButtonModule],
    styleUrls: ['./announcement.component.scss'],
    template: `
        @if (activeWindows.length) {
            <div class="announcement flex items-center justify-between gap-4 flex-wrap">
                <div>
                    <div class="announcement-title font-semibold mb-1">🏁 Renn-Anmeldung läuft!</div>
                    <div class="announcement-text">
                        Melde dich jetzt an:
                        <span class="announcement-highlight">{{ windowTitles }}</span>
                        @if (soonestDays !== null) { · endet in {{ soonestDays }} Tag(en) }
                    </div>
                </div>
                <a routerLink="/pages/registration">
                    <p-button label="Jetzt anmelden" icon="pi pi-flag" />
                </a>
            </div>
        }
    `,
})
export class RegistrationAnnouncementWidget implements OnInit {
    activeWindows: RegistrationWindow[] = [];
    windowTitles = '';
    soonestDays: number | null = null;

    constructor(private registrationService: RaceRegistrationService, private authService: AuthService) {}

    ngOnInit(): void {
        if (!this.authService.isLoggedIn()) { return; }
        this.registrationService.getActiveWindows().subscribe({
            next: (res) => {
                this.activeWindows = res.windows ?? [];
                this.windowTitles = this.activeWindows
                    .map((w) => w.title || w.round_date)
                    .join(', ');
                const days = this.activeWindows
                    .map((w) => (w.closes_at ? Math.ceil((new Date(w.closes_at.replace(' ', 'T')).getTime() - Date.now()) / 86400000) : null))
                    .filter((d): d is number => d !== null);
                this.soonestDays = days.length ? Math.max(0, Math.min(...days)) : null;
            },
            error: () => { /* silently hide on error */ },
        });
    }
}
